module.exports = __webpack_public_path__ + "static/media/2019_conf_Best_Practices_for_Product_Roadmaps.74c9d2d5.png";